// extracted by mini-css-extract-plugin
export default {"NotSynchronizedBadge":"ContentCardActions_NotSynchronizedBadge__9ryME","Synchronized":"ContentCardActions_Synchronized__KkLIH"};